import { useState } from 'react';

import classNames from 'classnames';

interface ToggleProps {
  initialState?: boolean;
  disabled?: boolean;
  checkedLabel?: string;
  uncheckedLabel?: string;
  onChange?: (checked: boolean) => void;
  className?: string;
  labelPosition?: 'left' | 'right';
}

const Toggle: React.FC<ToggleProps> = ({
  initialState,
  disabled,
  checkedLabel,
  uncheckedLabel,
  onChange,
  className,
  labelPosition = 'right',
}) => {
  const [checked, setChecked] = useState(initialState || false);

  const labelContent = (
    <span className="text-center text-xs font-medium text-foreground-default light:text-black">
      {checked ? checkedLabel : uncheckedLabel}
    </span>
  );

  const toggleSwitch = (
    <label
      className={classNames(
        'relative h-5 w-10 cursor-pointer rounded-full border transition-all duration-300',
        checked
          ? 'border-accent-default bg-accent-default'
          : 'border-pink-50 bg-accent-subtle light:bg-white',
        disabled ? 'cursor-not-allowed bg-accent-muted' : 'cursor-pointer',
      )}
    >
      <input
        type="checkbox"
        disabled={!!disabled}
        defaultChecked={!!checked}
        onChange={() => {
          setChecked(!checked);
          onChange?.(!checked);
        }}
        className="hidden"
      />
      <span
        className={classNames(
          'absolute top-[3px] h-3 w-3 rounded-full transition-all duration-300',
          checked
            ? 'left-[calc(100%-4px)] -translate-x-full transform bg-accent-subtle light:bg-white'
            : 'left-[4px] bg-accent-default',
        )}
      ></span>
    </label>
  );

  return (
    <div className={classNames('flex items-center gap-2', className)}>
      {labelPosition === 'left' && labelContent}
      {toggleSwitch}
      {labelPosition === 'right' && labelContent}
    </div>
  );
};

export { Toggle };
